import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/common';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-primary-50 flex items-center justify-center p-4">
      <div className="text-center animate-fade-in">
        {/* 404 Illustration */}
        <div className="relative mb-8">
          <span className="text-[120px] sm:text-[180px] font-bold text-primary-200 leading-none">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 sm:w-28 sm:h-28 bg-primary-100 rounded-full flex items-center justify-center">
              <svg
                className="w-12 h-12 sm:w-16 sm:h-16 text-primary-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-slate-500 mb-8 max-w-md mx-auto text-sm sm:text-base">
          Oops! The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="secondary" onClick={() => navigate(-1)}>
            <ArrowLeft size={18} className="mr-2" />
            Go Back
          </Button>
          <Button onClick={() => navigate('/')}>
            <Home size={18} className="mr-2" />
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
};
